module.exports = __webpack_public_path__ + "static/woman2-3x-7d55770b6507f8cfc539728fc61acbd2.png";